module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    staticStyle: {
      "z-index": "2"
    },
    style: ({
      width: _vm.sideBarWidth
    }),
    attrs: {
      "id": "sidebar"
    }
  }, [_c('nav', {
    staticClass: "sidebar-nav",
    style: ({
      width: _vm.barWidth
    })
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.siderbar_routers.children
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62026ff6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1092
// module chunks = 284